import React from "react";
import HeaderContainer from "../../components/header/HeaderContainer";
import HeaderTitle from "../../components/header/HeaderTitle";

import IKOintro01 from "../../assets/vendorProduct/IKOintro01.png";
import IKOintro02 from "../../assets/vendorProduct/IKOintro02.png";
import IKOintro03 from "../../assets/vendorProduct/IKOintro03.png";
import IKOintro04 from "../../assets/vendorProduct/IKOintro04.png";

import IKOstory from "../../assets/vendorProduct/IKOstory.png";
import IKODesignServices from "../../assets/vendorProduct/IkoDesingServices.png";

import IKOsolutions1 from "../../assets/vendorProduct/IKOsolutions1.png";
import IKOsolutions2 from "../../assets/vendorProduct/IKOsolutions2.png";
import IKOsolutions3 from "../../assets/vendorProduct/IKOsolutions3.png";
import IKOsolutions4 from "../../assets/vendorProduct/IKOsolutions4.png";
import IKOsolutions5 from "../../assets/vendorProduct/IKOsolutions5.png";
import IKOsolutions6 from "../../assets/vendorProduct/IKOsolutions6.png";
import IKOsolutions7 from "../../assets/vendorProduct/IKOsolutions7.png";
import IKOsolutions8 from "../../assets/vendorProduct/IKOsolutions8.png";
import IKOsolutions9 from "../../assets/vendorProduct/IKOsolutions9.png";
import IKOsolutions10 from "../../assets/vendorProduct/IKOsolutions10.png";
import IKOexamples from "../../assets/vendorProduct/IKOexamples.png";

import COLOR from "../../global/Color";
import SubHeading from "../../components/inner/venderProduct/SubHeading";
import FullImage from "../../components/inner/venderProduct/FullImage";
import styled from "styled-components";
import HeaderContent from "../../components/header/HeaderContent";
import HeaderContentSmall from "../../components/header/HeaderContentSmall";
import IKOIntro from "../../components/inner/venderProduct/IKOIntro";
import IKOSolutions from "../../components/inner/venderProduct/IKOSolutions";
import IKOTable from "../../components/inner/venderProduct/IKOTable";
import { useLanguage } from "../../context/LanguageContext";
import { siteCopy } from "../../i18n/landingCopy";

const Ikotek = () => {
  const { language } = useLanguage();
  const copy = siteCopy[language]?.pages?.vendor?.ikotek || siteCopy.en.pages.vendor.ikotek;

  const introIcons = [IKOintro01, IKOintro02, IKOintro03, IKOintro04];
  const renderLines = (lines = []) =>
    lines.map((line, index) => (
      <React.Fragment key={index}>
        {line}
        {index < lines.length - 1 && <br />}
      </React.Fragment>
    ));

  return (
    <>
      <HeaderContainer>
        <HeaderTitle>{copy.title}</HeaderTitle>
        <HeaderContent>
          <span style={{ color: COLOR.MAGORELLEBLUE, fontWeight: 700 }}>
            {copy.title.toLowerCase()}
            <span style={{ color: COLOR.BLACK, fontWeight: 300, display: "inline-block" }}></span>
          </span>
          (
          <a style={{ textDecoration: "underline", color: "black" }} href={copy.website} target="_blank">
            {copy.website}
          </a>
          ){renderLines(copy.headerIntro)}
        </HeaderContent>
        <HeaderContentSmall>{renderLines(copy.bodyParagraphs)}</HeaderContentSmall>
        <IKOIntroContainer>
          {introIcons.map((icon, index) => (
            <IKOIntro
              key={index}
              Icon={icon}
              Content={(copy.introCards && copy.introCards[index]) || ""}
            />
          ))}
        </IKOIntroContainer>
        <br />
        <br />
        <SubHeading>{copy.storyHeading}</SubHeading>
        <HeaderContentSmall>{renderLines([copy.storyParagraph])}</HeaderContentSmall>
        <ImageBoxContainer>
          <FullImage Item={IKOstory} />
        </ImageBoxContainer>
        <HeaderContentSmall>{renderLines([copy.historyParagraph])}</HeaderContentSmall>
        <br />
        <br />
        <ImageBoxContainer>
          <SubHeading>{copy.designHeading}</SubHeading>
          <HeaderContentSmall>{renderLines([copy.designParagraph])}</HeaderContentSmall>
          <FullImage Item={IKODesignServices} />
        </ImageBoxContainer>
        <br />
        <br />
        <SubHeading>{copy.solutionsHeading}</SubHeading>
        <HeaderContentSmall>{renderLines([copy.solutionsParagraph])}</HeaderContentSmall>
        <IKOSolutions
          Item={[
            IKOsolutions1,
            IKOsolutions2,
            IKOsolutions3,
            IKOsolutions4,
            IKOsolutions5,
            IKOsolutions6,
            IKOsolutions7,
            IKOsolutions8,
            IKOsolutions9,
            IKOsolutions10,
          ]}
        />
        <br />
        <br />

        <ImageBoxContainer>
          <SubHeading>{copy.currentExamplesHeading}</SubHeading>
          <FullImage Item={IKOexamples} />
        </ImageBoxContainer>

        <br />
        <br />

        <SubHeading>{copy.advantageHeading}</SubHeading>
        {(copy.advantageRows || []).map((row) => (
          <IKOTable key={row.title} Title={row.title} Content={row.content} bgColor={"#4A7090"} />
        ))}

        <br />
        <br />
        <br />
      </HeaderContainer>
    </>
  );
};

const ImageBoxContainer = styled.div`
  /* 450px 이상 800px 미만 */
  @media (min-width: 450px) and (max-width: 1300px) {
    display: none;
  }

  /* 450px 미만 */
  @media (max-width: 449px) {
    display: none;
  }
`;

const IKOIntroContainer = styled.div`
  width: 100%;
  height: auto;
  display: grid;
  grid-template-columns: repeat(2, 1fr);

  /* 450px 이상 800px 미만 */
  @media (min-width: 450px) and (max-width: 799px) {
    grid-template-columns: repeat(1, 1fr);
  }

  /* 450px 미만 */
  @media (max-width: 449px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export default Ikotek;
